// Admin wrapper for art gallery - passes admin flag
import ArtGallery from "../../art/index";

export default function AdminArtList() {
  return <ArtGallery admin />;
}
